/* Techphon – 1+1 Solo Loop-kiezer
 * Leest de producten van één collectie (JSON uit de sectie) en laat de klant
 * kastmaat, polsmaat en twee bandjes kiezen. Voegt beide varianten in één keer
 * toe aan de winkelwagen; de bestaande automatische 1+1-korting doet de rest.
 * Teksten komen uit de sectie (snippet slk-t, nl/de/fr/en); hieronder staat alleen de NL-reserve.
 * Geen externe bibliotheken. Werkt ook in preview.html (data-preview="true").
 */
(function () {
  'use strict';

  // Woorden die geen kleur zijn, in NL/DE/FR/EN (producttitels zijn per taal vertaald).
  var STOP = {};
  ('apple watch siliconen silicone silikon silicon gevlochten geweven braided woven geflochten geflochtenes gewebt gewebtes ' +
   'tressé tresse tissé solo loop soloband solobandje solobandjes soloarmband armband band bandje strap bracelet ' +
   'flecht flechtarmband silikonarmband ' +
   'voor für pour for in en de het een die der aus the of le la du kleur color colour couleur farbe').split(' ')
    .forEach(function (w) { STOP[w] = true; });
  var GEVLOCHTEN = /gevlochten|geweven|braided|woven|geflochten|gewebt|flecht|tress[ée]|tiss[ée]/i;
  var STANDAARD = {
    kies1: 'Kies je eerste bandje', kies2: 'Kies je tweede bandje (gratis)', slotLeeg: 'Kies bandje {n}',
    knop: 'In winkelwagen – 2 voor', bezig: 'Bezig…', maat: 'maat {m}', maatAria: 'Maat {m}', kleuren: '{n} kleuren',
    sil: 'Siliconen', gev: 'Gevlochten', nietInMaat: 'Niet in deze maat', nietAria: ', niet leverbaar in deze maat',
    vol: 'Je hebt al 2 bandjes gekozen. Verwijder er eerst één.',
    nietLeverbaar: 'Dit bandje is niet leverbaar in de gekozen maat.',
    fout: 'Het lukte niet om toe te voegen: {fout}. Probeer het opnieuw of kies een andere maat.',
    mislukt: 'Toevoegen mislukt'
  };
  var LOCALE = { nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', en: 'en-IE' };

  function maatNummer(waarde) {
    var m = String(waarde || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }
  function norm(waarde) { return String(waarde || '').replace(/\s+/g, ' ').trim(); }
  function vul(tekst, waarden) {
    return String(tekst).replace(/\{(\w+)\}/g, function (m, k) { return waarden[k] != null ? waarden[k] : m; });
  }
  // Bedrag (centen) volgens het geldformaat van de winkel, bijv. "€{{amount_with_comma_separator}}" -> €19,99.
  function maakGeld(formaat, reserve) {
    var m = String(formaat || '').replace(/<[^>]*>/g, '').match(/^(.*?)\{\{\s*(\w+)\s*\}\}(.*)$/);
    if (!m) return reserve;
    var stijl = {
      amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, '\'', '.'], amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', ',']
    }[m[2]];
    if (!stijl) return reserve;
    return function (centen) {
      var delen = (centen / 100).toFixed(stijl[0]).split('.');
      var heel = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, stijl[1]);
      return m[1] + heel + (delen[1] ? stijl[2] + delen[1] : '') + m[3];
    };
  }
  function soort(product) {
    var tags = (product.tags || []).map(function (t) { return String(t).toLowerCase(); });
    if (tags.indexOf('gevlochten') > -1) return 'gevlochten';
    if (tags.indexOf('siliconen') > -1) return 'siliconen';
    return GEVLOCHTEN.test(product.title) || GEVLOCHTEN.test(product.handle || '') ? 'gevlochten' : 'siliconen';
  }
  function schoon(tekst) {
    return String(tekst)
      .replace(/\b\d{2}\s?mm\b/gi, '')          // "41 mm"
      .replace(/\b[a-z0-9]{4,6}zm\/?a\b/gi, '')  // Apple-artikelnummers (MKX93ZM/A, mp9v3zma)
      .replace(/[–—\-|:\/]+/g, ' ')
      .split(/\s+/).filter(function (w) { return w && !STOP[w.toLowerCase()]; }).join(' ');
  }
  function hoofdletter(t) { return t ? t.charAt(0).toUpperCase() + t.slice(1) : t; }
  function kleurNaam(product) {
    if (product.kleur_naam) return product.kleur_naam;
    var t = schoon(String(product.title).replace(/\|.*$/, ''));   // eerst zonder SEO-toevoeging na "|"
    if (!t) t = schoon(product.title);                             // kleur stond juist na de "|"
    return hoofdletter(t) || product.title;
  }
  function handleNaam(product) {
    // Shopify zet "-1" achter dubbele handles; dat nummer is geen kleur.
    return hoofdletter(schoon(String(product.handle || '').replace(/-\d+$/, '').replace(/-/g, ' '))) || product.naam;
  }
  // Positie van de kastmaat-optie, herkend aan de waarde ("38/40/41 mm"): optienamen zijn per taal vertaald.
  function kastIndex(p) {
    var opts = p.variants && p.variants[0] ? p.variants[0].options : [];
    for (var i = 0; i < opts.length; i++) { if (/mm|\d+\s*\/\s*\d+/i.test(String(opts[i]))) return i; }
    return 0;
  }

  function Kiezer(root) {
    this.root = root;
    this.preview = root.getAttribute('data-preview') === 'true';
    var ruw = JSON.parse(root.querySelector('script[data-slk-producten]').textContent);
    var tekstEl = root.querySelector('script[data-slk-teksten]'), eigen = {};
    try { eigen = tekstEl ? JSON.parse(tekstEl.textContent) : {}; } catch (e) { eigen = {}; }
    this.t = {};
    for (var k in STANDAARD) { this.t[k] = eigen[k] || STANDAARD[k]; }
    this.taal = (root.getAttribute('data-taal') || 'nl').slice(0, 2).toLowerCase();
    var fmt;
    try { fmt = new Intl.NumberFormat(LOCALE[this.taal] || 'en-IE', { style: 'currency', currency: root.getAttribute('data-munt') || 'EUR' }); }
    catch (e) { fmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }); }
    this.geld = maakGeld(root.getAttribute('data-geldformaat'), function (centen) { return fmt.format(centen / 100); });
    this.cartUrl = root.getAttribute('data-cart-url') || '/cart';
    this.addUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    this.producten = ruw.filter(function (p) { return p && p.variants && p.variants.length; }).map(function (p) {
      var kastIdx = kastIndex(p);
      return {
        id: p.id, title: p.title, url: p.url, image: p.image, handle: p.handle,
        soort: soort(p), naam: kleurNaam(p), vasteNaam: !!p.kleur_naam,
        kastIdx: kastIdx, maatIdx: kastIdx === 0 ? 1 : 0,
        variants: p.variants
      };
    });
    // Dubbele namen binnen hetzelfde type onderscheiden via de producthandle (tenzij een metaveld de naam vastlegt).
    var tel = {};
    this.producten.forEach(function (p) { var k = p.soort + '|' + p.naam.toLowerCase(); tel[k] = (tel[k] || 0) + 1; });
    this.producten.forEach(function (p) {
      if (!p.vasteNaam && tel[p.soort + '|' + p.naam.toLowerCase()] > 1) p.naam = handleNaam(p);
    });
    var taal = this.taal;
    this.producten.sort(function (a, b) { return a.soort === b.soort ? a.naam.localeCompare(b.naam, taal) : (a.soort === 'siliconen' ? -1 : 1); });

    var kasten = {}, maten = {};
    this.producten.forEach(function (p) {
      p.variants.forEach(function (v) {
        kasten[norm(v.options[p.kastIdx])] = true;
        var m = maatNummer(v.options[p.maatIdx]); if (m) maten[m] = true;
      });
    });
    this.kasten = Object.keys(kasten).sort(function (a, b) { return maatNummer(a) - maatNummer(b); });
    this.maten = Object.keys(maten).map(Number).sort(function (a, b) { return a - b; });
    this.state = { kast: null, maat: null, filter: 'alle', keuzes: [null, null] };
    this.bouw();
  }

  Kiezer.prototype.variant = function (p) {
    var s = this.state;
    if (!s.kast || !s.maat) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (norm(v.options[p.kastIdx]) === s.kast && maatNummer(v.options[p.maatIdx]) === s.maat) return v;
    }
    return null;
  };

  Kiezer.prototype.$ = function (sel) { return this.root.querySelector(sel); };

  Kiezer.prototype.bouw = function () {
    var self = this;
    var kastBox = this.$('[data-slk-kasten]');
    kastBox.innerHTML = '';
    this.kasten.forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'slk-chip'; b.textContent = k; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { self.state.kast = k; self.wijzig(); });
      kastBox.appendChild(b);
    });
    var maatBox = this.$('[data-slk-maten]');
    maatBox.innerHTML = '';
    this.maten.forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'slk-chip slk-chip--maat'; b.textContent = m; b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', vul(self.t.maatAria, { m: m }));
      b.addEventListener('click', function () { self.state.maat = m; self.wijzig(); });
      maatBox.appendChild(b);
    });
    this.root.querySelectorAll('[data-slk-filter]').forEach(function (b) {
      b.addEventListener('click', function () { self.state.filter = b.getAttribute('data-slk-filter'); self.render(); });
    });
    this.root.querySelectorAll('[data-slk-wis]').forEach(function (b) {
      b.addEventListener('click', function () { self.state.keuzes[Number(b.getAttribute('data-slk-wis'))] = null; self.render(); });
    });
    this.$('[data-slk-add]').addEventListener('click', function () { self.toevoegen(); });
    this.render();
  };

  Kiezer.prototype.wijzig = function () {
    // Elk gekozen bandje onthoudt zijn eigen kast- en polsmaat. Een andere maat kiezen
    // geldt alleen voor het volgende bandje; reeds gekozen bandjes blijven ongewijzigd.
    this.melding('');
    this.render();
  };

  Kiezer.prototype.melding = function (tekst) {
    var el = this.$('[data-slk-melding]'); el.textContent = tekst; el.hidden = !tekst;
  };

  Kiezer.prototype.kies = function (p) {
    var k = this.state.keuzes;
    var vrij = k[0] == null ? 0 : (k[1] == null ? 1 : -1);
    if (vrij === -1) { this.melding(this.t.vol); return; }
    var v = this.variant(p);
    if (!v || !v.available) { this.melding(this.t.nietLeverbaar); return; }
    k[vrij] = { pid: p.id, variant: v, kast: this.state.kast, maat: this.state.maat };
    this.melding(''); this.render();
  };

  Kiezer.prototype.render = function () {
    var self = this, s = this.state, t = this.t, geld = this.geld, klaarVoorKeuze = !!(s.kast && s.maat);
    this.root.querySelectorAll('[data-slk-kasten] .slk-chip').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.textContent === s.kast));
    });
    this.root.querySelectorAll('[data-slk-maten] .slk-chip').forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.textContent) === s.maat));
    });
    this.root.querySelectorAll('[data-slk-filter]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-slk-filter') === s.filter));
    });
    this.$('[data-slk-stap3]').classList.toggle('slk-stap--inactief', !klaarVoorKeuze);
    this.$('[data-slk-hint]').hidden = klaarVoorKeuze;

    var grid = this.$('[data-slk-grid]'); grid.innerHTML = '';
    var aantal = 0;
    this.producten.forEach(function (p) {
      if (s.filter !== 'alle' && p.soort !== s.filter) return;
      var v = self.variant(p);
      var leverbaar = klaarVoorKeuze ? !!(v && v.available) : p.variants.some(function (x) { return x.available; });
      var nr = [];
      s.keuzes.forEach(function (k, i) { if (k && k.pid === p.id && k.kast === s.kast && k.maat === s.maat) nr.push(i + 1); });
      var soortTekst = p.soort === 'gevlochten' ? t.gev : t.sil;
      var kaart = document.createElement('button');
      kaart.type = 'button';
      kaart.className = 'slk-kaart' + (nr.length ? ' slk-kaart--gekozen' : '') + (!leverbaar ? ' slk-kaart--uit' : '');
      kaart.disabled = !klaarVoorKeuze || !leverbaar;
      kaart.setAttribute('aria-label', p.naam + ' (' + soortTekst + ')' + (leverbaar ? '' : t.nietAria));
      kaart.innerHTML =
        '<span class="slk-kaart__img">' + (p.image ? '<img loading="lazy" alt="" src="' + p.image + '">' : '') +
        (nr.length ? '<span class="slk-kaart__nr">' + nr.join('+') + '</span>' : '') + '</span>' +
        '<span class="slk-kaart__naam"></span><span class="slk-kaart__soort"></span>' +
        (klaarVoorKeuze && !leverbaar ? '<span class="slk-kaart__uit"></span>' : '');
      kaart.querySelector('.slk-kaart__naam').textContent = p.naam;
      kaart.querySelector('.slk-kaart__soort').textContent = soortTekst;
      if (klaarVoorKeuze && !leverbaar) kaart.querySelector('.slk-kaart__uit').textContent = t.nietInMaat;
      kaart.addEventListener('click', function () { self.kies(p); });
      grid.appendChild(kaart); aantal++;
    });
    this.$('[data-slk-aantal]').textContent = vul(t.kleuren, { n: aantal });

    // Samenvatting
    var totaal = 0, prijzen = [];
    s.keuzes.forEach(function (k, i) {
      var slot = self.$('[data-slk-slot="' + i + '"]');
      var naamEl = slot.querySelector('[data-slk-slot-naam]');
      var imgEl = slot.querySelector('[data-slk-slot-img]');
      var wis = slot.querySelector('[data-slk-wis]');
      var maatEl = slot.querySelector('[data-slk-slot-maat]');
      if (k == null) {
        naamEl.textContent = vul(t.slotLeeg, { n: i + 1 }); naamEl.title = ''; imgEl.innerHTML = ''; wis.hidden = true;
        slot.classList.remove('slk-slot--vol');
        if (maatEl) maatEl.textContent = '';
        return;
      }
      var p = self.producten.find(function (x) { return x.id === k.pid; });
      var v = k.variant;
      var maatTekst = k.kast + ' · ' + vul(t.maat, { m: k.maat });
      naamEl.textContent = p.naam;
      naamEl.title = p.naam + ' (' + (p.soort === 'gevlochten' ? t.gev : t.sil) + ') · ' + maatTekst;
      if (maatEl) maatEl.textContent = maatTekst;
      imgEl.innerHTML = p.image ? '<img alt="" src="' + p.image + '">' : '';
      wis.hidden = false; slot.classList.add('slk-slot--vol');
      if (v) { totaal += v.price; prijzen.push(v.price); }
    });
    var compleet = s.keuzes[0] != null && s.keuzes[1] != null;
    var korting = compleet ? Math.min.apply(null, prijzen) : 0;
    this.$('[data-slk-totaal-oud]').textContent = compleet ? geld(totaal) : '';
    this.$('[data-slk-totaal]').textContent = compleet ? geld(totaal - korting) : (prijzen.length ? geld(totaal) : '');
    var knop = this.$('[data-slk-add]');
    knop.disabled = !compleet;
    knop.textContent = compleet ? t.knop + ' ' + geld(totaal - korting) : (s.keuzes[0] == null ? t.kies1 : t.kies2);
  };

  Kiezer.prototype.toevoegen = function () {
    var self = this, s = this.state, regels = {};
    s.keuzes.forEach(function (k) {
      if (k && k.variant) regels[k.variant.id] = (regels[k.variant.id] || 0) + 1;
    });
    var items = Object.keys(regels).map(function (id) { return { id: Number(id), quantity: regels[id] }; });
    if (items.length === 0) return;
    if (this.preview) {
      this.melding('PREVIEW – zou toevoegen: ' + items.map(function (i) { return 'variant ' + i.id + ' × ' + i.quantity; }).join(', '));
      this.root.setAttribute('data-laatste-toevoeging', JSON.stringify(items));
      return;
    }
    var knop = this.$('[data-slk-add]'); knop.disabled = true; knop.textContent = this.t.bezig;
    fetch(this.addUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || self.t.mislukt); });
      window.location.href = self.cartUrl;
    }).catch(function (e) {
      self.melding(vul(self.t.fout, { fout: e.message }));
      self.render();
    });
  };

  function start() {
    document.querySelectorAll('[data-solo-loop-kiezer]').forEach(function (el) {
      if (!el.__slk) { el.__slk = new Kiezer(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start); // theme-editor
  window.TechphonSoloLoopKiezer = { start: start, _kleurNaam: kleurNaam, _maatNummer: maatNummer, _soort: soort, _kastIndex: kastIndex };
})();
